import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const ProductCard = ({ product }) => {
    const { add } = useCart();
    const handleAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        add(product, 1);
        toast.success(`${product.name} added to cart`);
    };

    return (
        <Link to={`/shop/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
            <div className="aspect-square overflow-hidden bg-[#F4F4F4] mb-5 relative">
                {product.image_url ? (
                    <img
                        src={product.image_url}
                        alt={product.name}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-[#FAFAFA] to-[#F0E6C8] text-[#B8860B]">
                        <div className="font-serif text-6xl italic">{product.name?.[0] || "·"}</div>
                        <div className="eyebrow text-[10px] mt-3">{product.category || "merch"}</div>
                    </div>
                )}
                <button
                    onClick={handleAdd}
                    data-testid={`add-to-cart-${product.id}`}
                    className="absolute bottom-4 left-4 right-4 bg-black text-white py-3 eyebrow text-[11px] opacity-0 group-hover:opacity-100 hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                >
                    Add to Cart
                </button>
            </div>
            <div className="flex justify-between items-baseline">
                <h3 className="font-serif text-lg md:text-xl tracking-tight">{product.name}</h3>
                <span className="font-sans text-sm tabular-nums">${product.price.toFixed(2)}</span>
            </div>
        </Link>
    );
};
